export const SET_TRIGGERS_TABLE_ITEMS = 'SET_TRIGGERS_TABLE_ITEMS';

export const setTriggersTableItems = itemsToDisplay => {
  return {
    type: SET_TRIGGERS_TABLE_ITEMS,
    data: itemsToDisplay,
  };
};
